import { atom, useAtom } from 'jotai';
import { useFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { useNodeSearch } from '@/features/connect-dots/hooks/useNodeSearch';

const TagViewDialogAtom = atom<boolean>(false);

const savedQueryAtom = atom<string>('');

export const useTagViewDialog = () => {
  const [isOpen, setIsOpen] = useAtom(TagViewDialogAtom);
  const [savedQuery, setSavedQuery] = useAtom(savedQueryAtom);
  const [filterCondition, setFilterCondition] = useFilterConditionAtom();
  const { resetSearchState } = useNodeSearch();

  const open = () => {
    setSavedQuery(filterCondition.query ?? '');
    setIsOpen(true);
  };

  const close = () => {
    setFilterCondition((prev) => ({
      ...prev,
      query: savedQuery,
    }));
    resetSearchState();
    setIsOpen(false);
  };

  return { isOpen, open, close };
};
